(function () {
  const section = document.querySelector('[data-jewelry-custom-process]');
  if (!section) return;

  const form = section.querySelector('[data-jcp-contact-form]');
  const fileInputs = section.querySelectorAll('[data-jcp-file-input]');
  const maxBytes = parseInt(section.dataset.maxFileBytes || '1048576', 10);
  const cloudName = (section.dataset.cloudName || '').trim();
  const uploadPreset = (section.dataset.uploadPreset || '').trim();
  const uploadUrlsField = section.querySelector('[data-jcp-upload-urls]');
  const submitBtn = section.querySelector('[data-jcp-submit]');
  const fileEmptyText = section.dataset.fileEmptyText || 'No file selected';

  function setFileNameDisplay(item, file) {
    const nameEl = item && item.querySelector('[data-jcp-file-name]');
    if (!nameEl) return;
    nameEl.textContent = file ? file.name : fileEmptyText;
  }

  function validateFile(file) {
    if (!file) return null;
    const okType = /^image\/(jpeg|png|webp)$/i.test(file.type) || /\.(jpe?g|png)$/i.test(file.name);
    if (!okType) return 'Only JPG or PNG images are allowed.';
    if (file.size > maxBytes) return 'Each image must be 1 MB or smaller.';
    return null;
  }

  fileInputs.forEach(function (input) {
    input.addEventListener('change', function () {
      const item = input.closest('[data-jcp-upload-item]');
      const errEl = item && item.querySelector('[data-jcp-file-error]');
      const file = input.files && input.files[0];

      if (errEl) errEl.textContent = '';
      if (item) item.classList.remove('is-error');

      if (!file) {
        setFileNameDisplay(item, null);
        return;
      }

      const err = validateFile(file);
      if (err) {
        if (errEl) errEl.textContent = err;
        if (item) item.classList.add('is-error');
        input.value = '';
        setFileNameDisplay(item, null);
        return;
      }

      setFileNameDisplay(item, file);
    });
  });

  async function uploadToCloudinary(file) {
    if (!cloudName || !uploadPreset) {
      throw new Error('Image upload is not configured. Please contact the store.');
    }
    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', uploadPreset);
    const res = await fetch('https://api.cloudinary.com/v1_1/' + cloudName + '/image/upload', {
      method: 'POST',
      body: formData
    });
    if (!res.ok) throw new Error('Upload failed for ' + file.name);
    const data = await res.json();
    return data.secure_url;
  }

  if (!form) return;

  form.addEventListener('submit', async function (e) {
    const files = [];
    fileInputs.forEach(function (input, index) {
      if (input.files && input.files[0]) {
        files.push({ input: input, file: input.files[0], slot: index + 1 });
      }
    });

    for (var i = 0; i < files.length; i++) {
      var err = validateFile(files[i].file);
      if (err) {
        e.preventDefault();
        alert(err);
        return;
      }
    }

    if (files.length === 0) return;

    if (!cloudName || !uploadPreset) {
      return;
    }

    e.preventDefault();
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = submitBtn.dataset.loadingText || 'Uploading…';
    }

    try {
      const urls = [];
      for (var j = 0; j < files.length; j++) {
        const url = await uploadToCloudinary(files[j].file);
        urls.push('Photo ' + files[j].slot + ': ' + url);
      }
      if (uploadUrlsField) {
        uploadUrlsField.value = urls.join('\n');
      }
      var bodyField = form.querySelector('#JCP-body');
      if (bodyField && uploadUrlsField && uploadUrlsField.value) {
        var prefix = bodyField.value.trim() ? bodyField.value.trim() + '\n\n' : '';
        bodyField.value = prefix + 'Reference photos:\n' + uploadUrlsField.value;
      }
      form.submit();
    } catch (uploadErr) {
      console.error(uploadErr);
      alert(uploadErr.message || 'Could not upload images. Please try again.');
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = submitBtn.dataset.defaultText || 'Submit';
      }
    }
  });
})();
